(() => {
  const productIds = new Set(
    (window.themeSettings?.autoRemoveProductIds || []).filter(Boolean).map(String),
  );

  if (productIds.size === 0) {
    return;
  }

  let isReconciling = false;
  let reconcileAgain = false;

  const getCart = () =>
    fetch(routes.cart_url, {
      headers: { Accept: "application/json" },
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Cart request failed with status ${response.status}`);
      }

      return response.json();
    });

  const refreshCartSections = async () => {
    const cartItems = document.querySelector("cart-items");
    const refreshes = [];

    if (cartItems) {
      refreshes.push(cartItems.updateSectionContents());
    }

    if (window.miniCart) {
      refreshes.push(window.miniCart.updateSectionContents());
    }

    await Promise.all(refreshes);
  };

  const reconcileCart = async (cartData) => {
    if (isReconciling) {
      reconcileAgain = true;
      return;
    }

    isReconciling = true;
    let currentCart = cartData;

    try {
      do {
        reconcileAgain = false;
        currentCart = currentCart?.items ? currentCart : await getCart();

        const updates = Object.fromEntries(
          currentCart.items
            .filter((item) => productIds.has(String(item.product_id)))
            .map((item) => [item.key, 0]),
        );

        if (Object.keys(updates).length > 0) {
          const response = await fetch(routes.cart_update_url, {
            ...fetchConfig(),
            body: JSON.stringify({ updates }),
          });

          if (!response.ok) {
            throw new Error(`Cart update failed with status ${response.status}`);
          }

          currentCart = await response.json();

          try {
            await refreshCartSections();
          } catch (error) {
            console.error("Unable to refresh cart sections after automatic removal:", error);
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-auto-remove",
            cartData: currentCart,
          });
        }

        currentCart = undefined;
      } while (reconcileAgain);
    } catch (error) {
      console.error("Unable to automatically remove configured cart products:", error);
    } finally {
      isReconciling = false;

      if (reconcileAgain) {
        reconcileCart();
      }
    }
  };

  subscribe(PUB_SUB_EVENTS.cartItemAdd, () => reconcileCart());
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source !== "cart-auto-remove") {
      reconcileCart(event.cartData);
    }
  });

  reconcileCart();
})();